var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function filterNftbyDollar(nft, hideSmall) {
    return nft.filter(function (item) { var _a; return !hideSmall || ((_a = item.floorPrice) !== null && _a !== void 0 ? _a : 0) >= 1; });
}
export function sortNfts(nft, sortBy) {
    return __spreadArray([], nft, true).sort(function (a, b) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        switch (sortBy) {
            case "az":
                return ((_a = a.name) !== null && _a !== void 0 ? _a : "").localeCompare((_b = b.name) !== null && _b !== void 0 ? _b : "");
            case "za":
                return ((_c = b.name) !== null && _c !== void 0 ? _c : "").localeCompare((_d = a.name) !== null && _d !== void 0 ? _d : "");
            case "low":
                return ((_e = a.floorPrice) !== null && _e !== void 0 ? _e : 0) - ((_f = b.floorPrice) !== null && _f !== void 0 ? _f : 0);
            case "high":
                return ((_g = b.floorPrice) !== null && _g !== void 0 ? _g : 0) - ((_h = a.floorPrice) !== null && _h !== void 0 ? _h : 0);
            default:
                return 0;
        }
    });
}
